module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/promo-ai-icon-e06d8ff6d8174f85af13d867811dc1fe.png";